export const TSymbolProp = '$$__BIM360_Matrix_Locale_Context_T_Symbol__$$';
export const defaultLocale = 'en';
